var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('admin-page-header',{attrs:{"title":"대시보드"}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center justify-content-center vh-100 bg-light"},[_c('div',{staticClass:"text-center"},[_c('h1',{staticClass:"title"},[_vm._v("준비중인 페이지 입니다.")]),_c('p',{staticClass:"description"},[_vm._v("곧 찾아뵙겠습니다!")]),_c('div',{staticClass:"spinner"})])])
}]

export { render, staticRenderFns }